<script lang="ts" setup>
import { parseBadgeClass, parseStatus } from '../../models/helpers'
import { OrderInterface, OrderType } from '../../models/OrderModel'

const props = defineProps<{
  order: OrderInterface
  type: OrderType
}>()

function parseTypeIcon(type: OrderType): string {
  if (type === OrderType.inbound) {
    return '📥'
  }
  if (type === OrderType.outbound) {
    return '📦'
  }
  if (type === OrderType.inventory) {
    return '📋'
  }
  if (type === OrderType.order) {
    return '🗃️'
  }
  if (type === OrderType.backorder) {
    return '📝'
  }
  return '🗂️'
}
</script>

<template>
  <div class="order-item">
    <div>
      <div class="d-flex gap-12">
        <div class="order-item__icon">
          {{ parseTypeIcon(props.order.type) }}
        </div>
        <div>
          <div v-if="props.order.order_title && order.type === OrderType.order">
            <b>{{ props.order.order_title }}</b>
          </div>
          <b class="text-break-word">{{ props.order.order_number }}</b
          >&nbsp;
          <small class="text-nowrap">{{ props.order.created_at }}</small>
          <div>
            <small>{{ props.order.warehouse.code }}</small>
          </div>
        </div>
      </div>
    </div>
    <div>
      <span :class="`badge badge--${parseBadgeClass(props.order.status)}`">
        {{ parseStatus(props.order.status) }}
      </span>
    </div>
    <RouterLink
      class="order-item__link"
      :to="{ name: 'order', params: { id: props.order.id }, query: { type: props.type } }"
    >
      {{ props.order.order_number }}
    </RouterLink>
  </div>
</template>
